import React from "react";
import { Container } from "react-bootstrap";
import Bike from "../../components/Bike/Bike";
import EditDetails from "./components/EditDetails/EditDetails";
import Filters from "./components/Filters/Filters";
import NoQuotes from "./components/NoQuotes/NoQuotes";
import Quotes from "./components/Quotes/Quotes";
import Addons from "./components/Filters/Addons/Addons";

const QuotesPage = () => {
  return (
    <>
      <Container>
        <EditDetails />
        <div className="quotes-page-row-container">
          <Filters />

          <Quotes />
          <div className="quotes-page-col-container">
            <Addons />
          </div>
        </div>
        <NoQuotes />
      </Container>
    </>
  );
};

export default QuotesPage;
